import React from 'react';
import styled from 'styled-components/macro';
import { Major } from '../utils/data_types';
import { THEME_COLORS } from '../utils/theme';
import { SectionHeader } from './styles';
import BarChart from './graphs/BarChart';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Graph = styled.div`
  width: 75vw;
  min-width: 0;
  min-height: 0;
  margin: 15px;
  padding: 15px;
`;

interface Props {
  majorData: Array<Major>;
}

export const TopMajor: React.FC<Props> = props => {
  let data = props.majorData;
  return (
    <>
      <SectionHeader color={THEME_COLORS.lightGrey}>Top Majors</SectionHeader>
      <Container>
        <Graph>
          <BarChart
            colNames={data.map(major => major.majorName)}
            data={data.map(major => major.totalMajor)}
            show_percentages={true}
          />
        </Graph>
      </Container>
    </>
  );
};
